import React, { Component } from "react";
import { connect } from "react-redux";
import { approveTrainingRequest, getTrainings } from "actions";
import "components/widgets/training/Training.css";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import {Trans} from "react-i18next";
import i18n from "i18next";

class ApprovePendingTrainingModal extends Component {
  state = {
    approveStatus: "init",
    error: null,
  };

  componentDidMount() {
    console.dir(this.props.training);
  }

  approveRequest = () => {
    this.props.approveTrainingRequest(
      this.props.training.recordId,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({ approveStatus: "success" });
    this.props.refresh();
  };
  onError = (e) => {
    this.props.onProcessEnd();
    console.dir(e);
    this.setState({ approveStatus: "error", error: e.message });
  };

  renderDescription = () => {
    const { name } = this.props.training.employee;
    const trainingName = this.props.training.training.name;
    //<strong>__employee__</strong> adlı çalışan tarafından talep edilen <strong>__training__</strong> eğitimine dair talebini onaylıyor musunuz?
    return (
      <div dangerouslySetInnerHTML={{__html: i18n.t(10506).replace("__employee__",name).replace("__training__",trainingName)}} />
    );
  };

  renderError = () => {
    return (
      <div className="pt-approve-container">
        <h5><Trans desc="İşlem sırasında bir hata oluştu">10507</Trans></h5>
        <p>{this.state.error}</p>
      </div>
    );
  };

  renderSuccess = () => {
    return (
      <div className="pt-approve-container">
        <h5><Trans desc="İşlem başarılı">10508</Trans></h5>
      </div>
    );
  };

  render() {
    if (this.state.approveStatus === "init") {
      return (
        <div className="pt-approve-container">
          {this.props.spinner}
          {this.renderDescription()}
          <button
            type="submit"
            className="btn btn-kaydet"
            onClick={() => this.approveRequest()}
          >
            <Trans desc="Onayla">10160</Trans>
          </button>
        </div>
      );
    } else if (this.state.approveStatus === "success") {
      return this.renderSuccess();
    } else {
      return this.renderError();
    }
  }
}

// export default connect(null, { approveTrainingRequest })(
//   containsLongRunningProcess(ApprovePendingTrainingModal)
// );


const mapStateToProps = (state) => {
  return {
    trainings: state.trainings,
  };
};

export default connect(mapStateToProps, {
  getTrainings,
  approveTrainingRequest,
})(containsLongRunningProcess(ApprovePendingTrainingModal));
